import React, { useState } from "react";

import {
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@material-ui/core";
import { DialogCancelButton, DialogButton } from "./styles";

interface Props {
  open: boolean;
  save: (s: string) => void;
  close: () => void;
  initalText?: string;
}

export default function UserValueDialog(props: Props) {
  const [text, setText] = useState<string>(props.initalText || "");

  return (
    <Dialog open={props.open}>
      <DialogContent>
        <div>
          <Typography>Name:</Typography>
          <TextField
            onChange={(event) => setText(event.target.value)}
            value={text}
          />
        </div>
        <DialogCancelButton
          onClick={() => {
            props.close();
          }}
        >
          Cancel
        </DialogCancelButton>

        <DialogButton
          onClick={() => {
            props.save(text);
            props.close();
          }}
        >
          Save
        </DialogButton>
      </DialogContent>
    </Dialog>
  );
}
